import React from "react";
import { Box, Container, Paper } from "@mui/material";
import TbsHeader from "../../../components/tbs/TbsHeader";

// The chrome for the management screens.
//
// **Not the storefront's `PageLayout`.** P0-6 reused it and that was wrong twice over: it renders
// `HeaderBar`, which puts a shopping cart, a product search and the shop's navigation on top of a
// POS screen; and it reads `state.cart.items`, which drags storefront Redux state into pages that
// have nothing to do with the shop. The second is what surfaced it — a detail-page test crashed on
// a cart that a management screen has no business having.
//
// `/gestion/*` is a different application for different people who happen to share a bundle
// (decision #15). Sharing a layout would make every storefront header change a change to the till.
//
// The shell was deliberately empty until `NAV-1` (`TBS-77`); `TbsHeader` is what fills it. It lives
// here rather than on each page for the same reason the company selector does — which is now inside
// it, alongside the account button: it is the same on every screen, and a page that forgot it would
// be a screen with no way out of itself.

interface Props {
  children: React.ReactNode;
  /** Full width for grids and the POS; contained for forms and detail views. */
  wide?: boolean;
}

export const TbsPageLayout: React.FC<Props> = ({ children, wide = false }) => (
  <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
    <TbsHeader />
    <Container maxWidth={wide ? false : "lg"} sx={{ py: 3 }}>
      <Paper sx={{ p: { xs: 2, sm: 3 } }}>{children}</Paper>
    </Container>
  </Box>
);

export default TbsPageLayout;
